var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRealTimeUpdates(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    height: 512,
    viewBox: "0 0 64 64",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m20 51a12 12 0 0 0 20.944 8l-1.49-1.333a10 10 0 1 1 2.546-6.667c0 .31-.03.616-.058.923l-1.142-1.523-1.6 1.2 3 4a1 1 0 0 0 1.6 0l3-4-1.6-1.2-1.268 1.691c.032-.362.068-.725.068-1.091a12 12 0 0 0 -24 0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m31 51.382-3.447 1.723.894 1.79 4-2a1 1 0 0 0 .553-.895v-8h-2z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m49 50h14v2h-14z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m1 50h17v2h-17z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m13 48v-22a1 1 0 0 0 -1-1h-8a1 1 0 0 0 -1 1v22h2v-21h6v21z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m28 15h-8a1 1 0 0 0 -1 1v26h2v-25h6v20h2v-21a1 1 0 0 0 -1-1z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m45 42v-16a1 1 0 0 0 -1-1h-8a1 1 0 0 0 -1 1v11h2v-10h6v15z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m61 48v-32a1 1 0 0 0 -1-1h-8a1 1 0 0 0 -1 1v32h2v-31h6v31z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m56 9a4 4 0 1 0 -4-4 3.952 3.952 0 0 0 .2 1.2l-9.456 5.9a3.978 3.978 0 0 0 -5.575.073l-10.339-6.083a3.935 3.935 0 0 0 .17-1.09 4 4 0 1 0 -7.7 1.522l-9.818 7.366a3.96 3.96 0 0 0 -2.482-.888 4.009 4.009 0 1 0 3.7 2.478l9.822-7.366a3.956 3.956 0 0 0 5.313-.289l10.335 6.087a3.935 3.935 0 0 0 -.17 1.09 4 4 0 0 0 8 0 3.952 3.952 0 0 0 -.2-1.2l9.456-5.9a3.978 3.978 0 0 0 2.744 1.1zm0-6a2 2 0 1 1 -2 2 2 2 0 0 1 2-2zm-49 16a2 2 0 1 1 2-2 2 2 0 0 1 -2 2zm16-12a2 2 0 1 1 2-2 2 2 0 0 1 -2 2zm17 10a2 2 0 1 1 2-2 2 2 0 0 1 -2 2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRealTimeUpdates);
export default __webpack_public_path__ + "static/media/Real-Time-Updates.f17e59b3f3d7e1d0d035b65a341fe7c5.svg";
export { ForwardRef as ReactComponent };